import { useCallback } from "react";
import { socket } from "../../socket";

function ConnectionManager({ isSocketConnected }) {
  const connectHandler = useCallback(() => {
    socket.connect();
  }, []);

  const disconnectHandler = useCallback(() => {
    socket.disconnect();
  }, []);

  return (
    <span>
      <button
        onClick={
          isSocketConnected ? disconnectHandler : connectHandler
        }
      >
        {isSocketConnected ? "Disconnect" : "Connect"}
      </button>
    </span>
  );
}

export default ConnectionManager;
